import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

import backendService from '../services/backendService';

export const useQueryGeneratorsByStandard = ({ standardId }: { standardId: string }) => {
  const cacheKey = useMemo(() => {
    const key = ['generators-by-standard', standardId];
    return key;
  }, [standardId]);

  const { data: generators, isFetching: isFetchingGenerators } = useQuery(
    cacheKey,
    async _ => {
      return backendService.instance.generators.searchByStandard({
        standardId,
      });
    },
    {
      staleTime: 1000 * 60 * 5,
    },
  );

  return {
    generators: generators?.items || [],
    isFetchingGenerators,
  };
};
